export default __webpack_public_path__ + "static/media/33.46862f63.jpeg";